import React, { useEffect, useState } from 'react';
import styles from '../../../assets/css/vendors/vendors.module.css';
import PropTypes from 'prop-types';
import CreateForm from './CreateForm';
import Button from '../../../components/button/Button';

const CreateVendor = ({ step, steps, nextStep, flag, backHome }) => {
    const [view, setView] = useState(false);
    const handleCreate = event => {
        event.preventDefault();
    };

    const handleNext = state => {
        steps[step].formList.forEach(element => {
            if (element.type === 'select') {
                const el = document.getElementById(element.name + '_list');
                el.style.display = 'none';
            }
        });
        nextStep(state);
    };

    useEffect(() => {
        steps[step].view ? setView(true) : setView(false);
    }, [step, steps]);

    const content = (
        <div
            className={`${!view ? styles.login__body : styles.container_form} ${
                styles.text_align_center
            }`}>
            <div className={`${!view && styles.login__input}`}>
                <CreateForm
                    step={step}
                    flag={flag}
                    steps={steps}
                    view={view}
                    handleSubmit={handleCreate}>
                    <div className={!view ? styles.item : styles.btn_items}>
                        {step + 1 < steps.length && (
                            <Button
                                text={'Back'}
                                classs={'btnOutlineMain'}
                                color={'grayLight'}
                                onClick={() =>
                                    step === 0
                                        ? backHome(false)
                                        : handleNext(false)
                                }
                            />
                        )}
                        {/* )} */}

                        <Button
                            text={
                                step + 1 === steps.length
                                    ? 'Go to profile'
                                    : 'Next'
                            }
                            classs={'btnMain'}
                            onClick={() => handleNext(true)}
                        />
                    </div>
                </CreateForm>
            </div>
        </div>
    );
    return <div className={styles.login__container}>{content}</div>;
};

CreateVendor.propTypes = {
    view: PropTypes.number,
    steps: PropTypes.array,
    step: PropTypes.number,
    nextStep: PropTypes.any,
    flag: PropTypes.bool,
    backHome: PropTypes.any
};

export default CreateVendor;
